import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Unit, UnitService } from '../../services/unit.service';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-update-unit',
  templateUrl: './update-unit.component.html',
  styleUrls: ['./update-unit.component.css']
})
export class UpdateUnitComponent implements OnInit, OnDestroy {

  tipos=[
    {name:'Elija un tipo...',value:''},
    {name:'Área',value:'Área'},
    {name:'Longitud',value:'Longitud'},
    {name:'Peso',value:'Peso'},
    {name:'Tiempo',value:'Tiempo'},
    {name:'Velocidad',value:'Velocidad'},
    {name:'Volumen Líquido',value:'Volumen Líquido'},
    {name:'Volumen Sólido',value:'Volumen Sólido'},
    {name:'Cantidad',value:'Cantidad'},
    {name: 'Otros',value:'Otros'},
  ];

  unitForm: FormGroup;
  sid: string;
  unit: any;
  subsciptionUnit: Subscription;

  constructor(
    private unitService: UnitService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createForm();
    this.subsciptionUnit = this.unitService.getUnit(this.sid).subscribe(data => {
      this.unit = data;
      this.unitForm.get('name').setValue(data.name);
      this.unitForm.get('symbol').setValue(data.symbol);
      this.unitForm.get('type').setValue(data.type);
      this.unitForm.get('value').setValue(data.value);
      this.unitForm.get('reference').setValue(data.reference);
    });
  }

  ngOnDestroy() {
    this.subsciptionUnit.unsubscribe();
  }

  createForm() {
    this.unitForm = this.fb.group({
      name: ['', Validators.required],
      symbol: ['', Validators.required],
      type: ['', Validators.required],
      value: ['', Validators.required],
      reference: ['', Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    this.unitService.updateUnit(this.sid, value);
  }
}
